module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_panel) ? _c('section', {
    attrs: {
      "id": "shot-con"
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-guanbicopyx"
    }
  })])]), _vm._v(" "), (_vm.show_loading) ? _c('section', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/%E6%9C%AA%E6%A0%87%E9%A2%98-1.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("生成分享卡片中...")])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "screen-shot",
    attrs: {
      "id": "shot"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sec"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hidepic"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "myCanvas"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "showPic",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tip-button"
  }, [_vm._v("长按保存图片"), _c('br'), _vm._v("转发分享现场直播")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bac1080"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XShot/Shot.vue
// module id = 532
// module chunks = 1